import { createContext, useContext } from "react";

export const SiteContext = createContext({ settings: null, pricing: null, scrollTo: () => {} });
export const useSite = () => useContext(SiteContext);
